module.exports = __webpack_public_path__ + "img/judges-icon.afc37463.png";